import axios from 'axios';
import { getLoggedInUserRole, getLoggedInUsername } from '../utils/auth';
import { throwUnlessApiSuccess } from '../utils/apiResponse';

export const FETCH_STOKEZES_REQUEST = 'FETCH_STOKEZES_REQUEST';
export const FETCH_STOKEZES_SUCCESS = 'FETCH_STOKEZES_SUCCESS';
export const FETCH_STOKEZES_FAILURE = 'FETCH_STOKEZES_FAILURE';
export const CREATE_STOKEZ_SUCCESS = 'CREATE_STOKEZ_SUCCESS';
export const UPDATE_STOKEZ_SUCCESS = 'UPDATE_STOKEZ_SUCCESS';
export const DELETE_STOKEZ_SUCCESS = 'DELETE_STOKEZ_SUCCESS';
export const TOGGLE_LOCK_STOKEZ_SUCCESS = 'TOGGLE_LOCK_STOKEZ_SUCCESS';
const base_url  = process.env.REACT_APP_API_URL_ADMIN;

export const getStokezes = () => async (dispatch) => {
  dispatch({ type: FETCH_STOKEZES_REQUEST });
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const loggedInUsername = getLoggedInUsername();
    const response = await axios.post(`${base_url}`, {
      apiName: 'stokez',
      command: 'getStokezes',
      loggedInUserRole,
      loggedInUsername
    });
    dispatch({ type: FETCH_STOKEZES_SUCCESS, payload: response.data.data });
  } catch (error) {
    dispatch({ type: FETCH_STOKEZES_FAILURE, payload: error.message || error.response?.data?.message || 'Failed to fetch stokezs' });
  }
};

export const createStokez = (stokezData) => async (dispatch) => {
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const response = await axios.post(`${base_url}`, {
      apiName: 'stokez',
      command: 'createStokez',
      loggedInUserRole,
      ...stokezData,
    });
    const data = throwUnlessApiSuccess(response);
    dispatch({ type: CREATE_STOKEZ_SUCCESS, payload: data });
    return response.data;
  } catch (error) { console.error('Failed to create stokez:', error); throw error; }
};

export const updateStokez = (stokezId, updateData) => async (dispatch) => {
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const response = await axios.post(`${base_url}`, {
      apiName: 'stokez',
      command: 'updateStokez',
      stokezId,
      updateData,
      loggedInUserRole,
    });
    const data = throwUnlessApiSuccess(response);
    dispatch({ type: UPDATE_STOKEZ_SUCCESS, payload: data });
    return response.data;
  } catch (error) { console.error('Failed to update stokez:', error); throw error; }
};

export const deleteStokez = (stokezId) => async (dispatch) => {
  try {
    await axios.post(`${base_url}`, { apiName: 'stokez', command: 'deleteStokez', stokezId });
    dispatch({ type: DELETE_STOKEZ_SUCCESS, payload: stokezId });
  } catch (error) { console.error('Failed to delete stokez:', error); throw error; }
};

export const toggleLockStokez = (stokezId) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, { apiName: 'stokez', command: 'toggleLockStokez', stokezId });
    const data = throwUnlessApiSuccess(response);
    dispatch({ type: TOGGLE_LOCK_STOKEZ_SUCCESS, payload: data });
    return response.data;
  } catch (error) { throw error; }
};
